import styled, { createGlobalStyle } from 'styled-components';

export const Wrapper = styled('div')`
  min-height: 100vh;
`;

export const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 150px 0;
`;

export const GlobalResetStyles = createGlobalStyle`
  .planne-widget-direct-link * {
    box-sizing: border-box;
  }

  .modal-open {
    overflow: hidden !important;
  }

  .planne-widget-modal * {
    box-sizing: border-box;
  }

  .planne-widget-drawer * {
    box-sizing: border-box;
  }
`;
